import leanAbs from "@/male/assets/body-scan-funnel/abs-target-body-type/lean.webp";
import muscularAbs from "@/male/assets/body-scan-funnel/abs-target-body-type/muscular.webp";
import rippedAbs from "@/male/assets/body-scan-funnel/abs-target-body-type/ripped.webp";
import curvy from "@/male/assets/paywall-body/curvy.webp";
import imgSkinny from "@/male/assets/paywall-body/Ectomorph.png";
import imgExtra from "@/male/assets/paywall-body/Endomorph.png";
import extra from "@/male/assets/paywall-body/extra.png";
import lean from "@/male/assets/paywall-body/lean.webp";
import imgCut from "@/male/assets/paywall-body/lean.webp";
import imgRegular from "@/male/assets/paywall-body/Mesomorph.png";
import muscular from "@/male/assets/paywall-body/muscular.webp";
import ripped from "@/male/assets/paywall-body/ripped.webp";
import upgradedCurvy from "@/male/assets/upgraded/body-type-target/curvy.webp";
import upgradedLean from "@/male/assets/upgraded/body-type-target/lean.webp";
import upgradedMuscular from "@/male/assets/upgraded/body-type-target/muscular.webp";
import upgradedRipped from "@/male/assets/upgraded/body-type-target/ripped.webp";

interface ManBodyPicByBodyId {
    skinny: string;
    regular: string;
    extra: string;
    cut: string;
    bulk: string;
    extra_bulk: string;
    lean: string;
    muscular: string;
    ripped: string;
    curvy: string;
    slightly_extra: string;
}
export const manBodyPicByBodyId: ManBodyPicByBodyId = {
    skinny: imgSkinny,
    regular: imgRegular,
    extra: extra,
    cut: imgCut,
    bulk: muscular,
    extra_bulk: ripped,
    lean: lean,
    muscular: muscular,
    ripped: ripped,
    curvy: curvy,
    slightly_extra: imgExtra,
};

export const manAbsTargetBodyPic = {
    lean: leanAbs,
    muscular: muscularAbs,
    ripped: rippedAbs,
};

export const upgradedBodyPicByBodyId: Partial<ManBodyPicByBodyId> = {
    lean: upgradedLean,
    muscular: upgradedMuscular,
    curvy: upgradedCurvy,
    ripped: upgradedRipped,
};
